import RadioGroupFormField from '../../radio-group-form-field';
import { decodeHtmlEntities } from '../utils/decode-html-entities';
import { jsx as _jsx } from "react/jsx-runtime";

var RadioInput = function RadioInput(_ref) {
  var name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      options = _ref.options,
      _ref$questionForm = _ref.questionForm,
      control = _ref$questionForm.control,
      errors = _ref$questionForm.formState.errors;
  return /*#__PURE__*/_jsx(RadioGroupFormField, {
    control: control,
    name: name,
    required: required,
    options: options.map(function (o) {
      return {
        label: decodeHtmlEntities(o.description),
        value: o.description
      };
    }),
    error: errors[name],
    "data-element": "RadioGroupFormField",
    "data-component": "RadioInput",
    "data-source-file": "radio.tsx"
  });
};

export default RadioInput;